// Управление полем поиска модулей:
//  - если введена поисковая фраза, поле поиска открыто;
//  - кнопка очистки опустошает поле;
//  - при закрытии поля очищаем его и сбрасываем состояние —
//    перезагружаем страницу без поискового запроса.
export default function searchToggle(form) {
    const panel = form.closest(".filters-panel");
    const field = form.querySelector(".field");
    const clearButton = form.querySelector(".clear-button");
    const closeButton = form.querySelector(".close-search-button");
    const openButton = panel ? panel.querySelector(".open-search-button") : null;

    // Если введена поисковая фраза — поле поиска открыто
    if (field && field.value.trim() !== "") {
        form.classList.add("open");
    }

    if (openButton) {
        openButton.addEventListener("click", function (event) {
            event.stopPropagation();
            form.classList.add("open");
            if (field) {
                field.focus();
            }
        });
    }

    if (clearButton && field) {
        clearButton.addEventListener("click", function (event) {
            event.stopPropagation();
            field.value = "";
            field.dispatchEvent(new CustomEvent("input"));
            field.focus();
        });
    }

    if (closeButton) {
        closeButton.addEventListener("click", function (event) {
            event.stopPropagation();

            const resetUrl = resetUrlWithoutFind();
            if (resetUrl !== null) {
                // Активный поиск — сбрасываем состояние перезагрузкой без поисковой фразы
                window.location.assign(resetUrl);
                return;
            }

            // Активного поиска нет — просто очищаем поле и закрываем
            if (field) {
                field.value = "";
                field.dispatchEvent(new CustomEvent("input"));
            }
            form.classList.remove("open");
        });
    }
}

// Возвращает текущий путь без сегмента поискового запроса find/<значение>
// или null, если поискового запроса в адресе нет.
function resetUrlWithoutFind() {
    const segments = window.location.pathname.split("/");
    const result = [];
    let found = false;

    for (let i = 0; i < segments.length; i++) {
        if (decodeURIComponent(segments[i]).toLowerCase() === "find") {
            found = true;
            i++; // пропускаем значение поискового запроса
            continue;
        }
        result.push(segments[i]);
    }

    if (!found) {
        return null;
    }

    let pathname = result.join("/");
    if (!pathname.endsWith("/")) {
        pathname += "/";
    }

    return pathname + window.location.search + window.location.hash;
}
